import React, { useEffect, useState } from "react";
import {
  getUserById,
  connectUsers,
  notInterested,
  GetConnectionStatus,
  checkIfuserIsConnected,
} from "../api/api";
import { environment } from "../../environments/environments";
import Swal from "sweetalert2";
import "./MemberProfileModal.css";
import { useNavigate } from "react-router-dom";
import pendingIcon from "../../assets/images/pending.png";
import verifyIcon from "../../assets/images/verified-badges.png";

const MemberProfileModal = ({ memberId, onClose, history }) => {
  const [memberData, setMemberData] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [expandedSections, setExpandedSections] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [isRequestSent, setIsRequestSent] = useState(false);
  const [isRequestReceived, setIsRequestReceived] = useState(false);
  const [isMemberNotInterested, setIsMemberNotInterested] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [backgroundIndex, setBackgroundIndex] = useState(0);
  const [backgroundImages, setBackgroundImages] = useState([]);
  const [checkConnectUser, setcheckCoonectUser] = useState("");

  useEffect(() => {
    CheckifConnectedUser();
  }, []);

  const CheckifConnectedUser = async () => {
    setIsLoading(true);
    try {
      const userData = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userData);
      const _id = parsedUserData?.id || parsedUserData?._id;
      if (_id) {
        const values = {
          user_id: _id,
          target_user_id: memberId,
        };
        const currentUser = await checkIfuserIsConnected(values);
        setcheckCoonectUser(currentUser);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (memberData?.more_images?.length) {
      const images = memberData.more_images.map(
        (img) => `${environment.url}uploads/users/${img}`
      );
      setBackgroundImages(images);
    }
  }, [memberData]);

  useEffect(() => {
    if (backgroundImages.length === 0) return;
    const interval = setInterval(() => {
      setBackgroundIndex(
        (prevIndex) => (prevIndex + 1) % backgroundImages.length
      );
    }, 3000);
    return () => clearInterval(interval);
  }, [backgroundImages]);
  const currentBackgroundImage = backgroundImages[backgroundIndex];

  const getCurrentUserId = () => {
    const raw = localStorage.getItem("currentUser");
    const parsed = JSON.parse(raw);
    return parsed?.id || parsed?._id;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const memberRes = await getUserById({ user_id: memberId });
        const data = memberRes.data;
        setMemberData(data);
        const moreImages = data.more_images;
        setImageUrl(
          moreImages?.length
            ? `${environment.url}uploads/users/${moreImages[0]}`
            : data.image
        );

        const me = getCurrentUserId();
        const meRes = await getUserById({ user_id: me });
        const sent = new Set(meRes.data.interests_sent || []);
        const received = new Set(meRes.data.interests_received || []);
        setIsRequestSent(sent.has(memberId));
        setIsRequestReceived(received.has(memberId));

        const connRes = await GetConnectionStatus({
          user_id: me,
          target_user_id: memberId,
        });
        setIsConnected(connRes?.data?.status === "1");
        setIsMemberNotInterested(meRes.data.not_interested?.includes(memberId));
        const keys = [];
        if (data.bio) keys.push("bio");
        if (data.love_language?.preferred_love_receiving_method)
          keys.push("receive");
        if (data.love_language?.preferred_love_giving_method) keys.push("give");
        if (data.love_language?.importance_of_quality_time)
          keys.push("qualityTime");
        if (data.love_language?.words_vs_actions_affection)
          keys.push("wordsVsActions");
        if (data.love_language?.stress_support_preference)
          keys.push("stressSupport");
        setExpandedSections(keys);
      } catch (err) {
        console.error("Error loading profile:", err);
      } finally {
        setIsLoading(false);
      }
    };
    if (memberId) fetchData();
  }, [memberId]);

  const handleSendInterest = async () => {
    try {
      const me = getCurrentUserId();
      const res = await connectUsers({
        user_id: me,
        match_confirm_user_id: memberId,
      });
      if (res.success) {
        Swal.fire("Success", res.message, "success").then(() => {
          onClose();
        });
        setIsRequestSent(true);
      } else {
        Swal.fire("Oops", res.message, "error").then(() => {
          onClose();
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Unable to send interest", "error").then(() => {
        onClose();
      });
    }
  };

  const handleNotInterested = async () => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    });
    if (!confirm.isConfirmed) return;

    try {
      const me = getCurrentUserId();
      const res = await notInterested({
        user_id: me,
        target_user_id: memberId,
      });
      if (res.success) {
        Swal.fire("Done", res.message, "success");
        setIsMemberNotInterested(true);
      } else {
        Swal.fire("Error", res.message, "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const handleChat = () => {
    if (!isConnected) return;
    console.log("chattttt", memberData?.approve_reject_new_image);
    if (memberData?.approve_reject_new_image === "pending") {
      Swal.fire({
        icon: "info",
        title: "Pending Profile",
        text: "This user profile is still pending. Please try again later.",
      });
    } else {
      navigate(`/Sidebar/chat/${memberId}`);
    }
    // navigate(`/Sidebar/chat/${memberId}`);
  };

  const toggleSection = (key) => {
    setExpandedSections((prev) =>
      prev.includes(key) ? prev.filter((item) => item !== key) : [...prev, key]
    );
  };

  if (isLoading || !memberData) return null;

  return (
    <div className="modal-overlay">
      <div
        className="modal-card"
        style={{
          backgroundImage: `url(${currentBackgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <span className="modal-close2" onClick={onClose}>
          &times;
        </span>

        {imageUrl && (
          <div className="image-divss">
            <img src={imageUrl} alt="Profile" className="modal-image" />
          </div>
        )}
        <div className="detaildiv">
          <div className="detail-inner-wrapper">
            <div className="memberuserName">
              <p>{memberData?.name}</p>
              {memberData?.approve_reject_new_image === "pending" ? (
                <img
                  src={pendingIcon}
                  alt="Pending"
                  className="member-status-icon"
                />
              ) : (
                <img
                  src={verifyIcon}
                  alt="Verified"
                  className="member-status-icon"
                />
              )}
            </div>
            <div className="memberuseryear">
              <p>{memberData?.age}</p> <p>Years</p>
            </div>
            <div className="modal-info">
              {[
                { label: "DOB", value: memberData.dob },
                { label: "Gender", value: memberData.gender },
                { label: "Profession", value: memberData.profession },
              ].map(({ label, value }) => (
                <div className="valueMainDiv" key={label}>
                  <div className="valueTitle">
                    <strong>{label}</strong>
                  </div>
                  <div className="valuedots">
                    <strong>:</strong>
                  </div>
                  <div className="valueValue">
                    <p>{value || "N/A"}</p>
                  </div>
                </div>
              ))}
            </div>
            {memberData.user_interests_list &&
              memberData.user_interests_list.length > 0 && (
                <div className="modal-info">
                  <div className="InterestMainDiv">
                    <div className="valueTitleinterest">
                      <strong className="strongInterest">Interests</strong>
                    </div>
                    <div
                      className="valueDiv"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "8px",
                        marginLeft: 35,
                      }}
                    >
                      {memberData.user_interests_list.map((interest) => (
                        <span key={interest.id} className="spandiv">
                          {interest.name}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              )}

            {memberData.bio && (
              <div className="expand-section">
                <h4
                  onClick={() => toggleSection("bio")}
                  className="expand-title"
                >
                  BIO {expandedSections.includes("bio") ? "▲" : "▼"}
                  {expandedSections.includes("bio") && <p>{memberData.bio}</p>}
                </h4>
              </div>
            )}

            {memberData.love_language && (
              <>
                {[
                  {
                    key: "receive",
                    title:
                      "How do you prefer to receive love from your partner?",
                    value:
                      memberData.love_language.preferred_love_receiving_method,
                  },
                  {
                    key: "give",
                    title:
                      "What is the most meaningful way for you to show love to someone?",
                    value:
                      memberData.love_language.preferred_love_giving_method,
                  },
                  {
                    key: "qualityTime",
                    title:
                      "How important is quality time and undivided attention in your relationship?",
                    value: memberData.love_language.importance_of_quality_time,
                  },
                  {
                    key: "wordsVsActions",
                    title:
                      "How do you feel about expressing affection through words versus actions?",
                    value: memberData.love_language.words_vs_actions_affection,
                  },
                  {
                    key: "stressSupport",
                    title:
                      "What helps you feel most supported and cared for during stressful times?",
                    value: memberData.love_language.stress_support_preference,
                  },
                ].map(({ key, title, value }) =>
                  value ? (
                    <div className="expand-section" key={key}>
                      <h4
                        onClick={() => toggleSection(key)}
                        className="expand-title"
                      >
                        {title} {expandedSections.includes(key) ? "▲" : "▼"}
                        {expandedSections.includes(key) && <p>{value}</p>}
                      </h4>
                    </div>
                  ) : null
                )}
              </>
            )}
            <div className="divider-line"></div>
            <div
              onClick={() => setModalVisible(true)}
              className="profile-details-wrapper"
            >
              <div className="profile-details-inner">
                <span className="profile-details-text">
                  Click To View More Profile Details
                </span>
              </div>
            </div>
            <div className="modal-footer">
              {/* {!isRequestSent &&
                !isRequestReceived &&
                !isMemberNotInterested &&
                !isConnected && (
                  <button
                    className="interest-btn-first"
                    onClick={handleSendInterest}
                  >
                    Send Interest
                  </button>
                )} */}
              {!isRequestSent &&
                !isRequestReceived &&
                !isMemberNotInterested &&
                !isConnected &&
                checkConnectUser?.connected === false && (
                  <button
                    className="interest-btn-first"
                    onClick={handleSendInterest}
                  >
                    Send Interest
                  </button>
                )}

              {(isRequestSent || isRequestReceived) && (
                /*!isConnected &&*/ <button className="interest-btn" disabled>
                  {isRequestSent ? "Request Sent" : "Request Received"}
                </button>
              )}

              {/* {isConnected && (
                <button className="chat-btn" onClick={handleChat}>
                  Chat
                </button>
              )} */}
              {checkConnectUser?.connected !== false &&
                (isConnected /*?.data?.status === "1" */ ? (
                  <button className="chat-btn" onClick={handleChat}>
                    Chat
                  </button>
                ) : (
                  <button className="chat-btn" disabled>
                    Chat
                  </button>
                ))}

              {/* {!isMemberNotInterested &&
                !isRequestSent &&
                !isRequestReceived &&
                !isConnected && ( */}
              <button
                className="not-interest-btn"
                onClick={handleNotInterested}
              >
                Not Interested
              </button>
              {/* )} */}

              {/* {(isMemberNotInterested ||
                isRequestSent ||
                isRequestReceived ||
                isConnected) && (
                <button className="not-interest-btn" disabled>
                  Not Interested
                </button>
              )} */}
            </div>
          </div>
        </div>
      </div>
      {modalVisible && (
        <div className="nested-modal-overlay">
          <div className="nested-modal-card">
            <span
              className="nested-modal-close"
              onClick={() => setModalVisible(false)}
            >
              &times;
            </span>
            <h2 className="profileDetails">Profile Details</h2>
            <div className="modal-scrollable-content">
              {memberData?.more_profile_details?.relationship_status && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Relationship Status
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {memberData?.more_profile_details?.relationship_status ||
                        "N/A"}
                    </p>
                  </div>
                </div>
              )}
              {memberData?.more_profile_details?.ethnicity && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Ethnicity
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {memberData?.more_profile_details?.ethnicity || "N/A"}
                    </p>
                  </div>
                </div>
              )}
              {memberData?.more_profile_details?.religion && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Religion
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {memberData?.more_profile_details?.religion || "N/A"}
                    </p>
                  </div>
                </div>
              )}
              {memberData?.more_profile_details?.education_level && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Education Level
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {memberData?.more_profile_details?.education_level ||
                        "N/A"}
                    </p>
                  </div>
                </div>
              )}
              {memberData?.more_profile_details?.occupation && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Occupation
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {memberData?.more_profile_details?.occupation || "N/A"}
                    </p>
                  </div>
                </div>
              )}
              {/* {memberData?.more_profile_details?.income && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Annual Income
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {memberData?.more_profile_details?.income || "N/A"}
                    </p>
                  </div>
                </div>
              )} */}
              {memberData?.more_profile_details?.have_children && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Has Children?
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {memberData?.more_profile_details?.have_children || "N/A"}
                    </p>
                  </div>
                </div>
              )}
              {memberData?.more_profile_details?.want_children && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Wants Children?
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {memberData?.more_profile_details?.want_children || "N/A"}
                    </p>
                  </div>
                </div>
              )}
              {memberData?.more_profile_details?.blood_group && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Blood Group
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {memberData?.more_profile_details?.blood_group || "N/A"}
                    </p>
                  </div>
                </div>
              )}
              {memberData?.more_profile_details?.hair_color && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Hair Color
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {memberData?.more_profile_details?.hair_color || "N/A"}
                    </p>
                  </div>
                </div>
              )}
              {memberData?.more_profile_details?.language_spoken && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Language Spoken
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {(
                        memberData?.more_profile_details?.language_spoken || []
                      ).join(", ") || "N/A"}
                    </p>
                  </div>
                </div>
              )}
              {memberData?.more_profile_details?.preferred_game_genere && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Preferred Game Genere
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {(
                        memberData?.more_profile_details
                          ?.preferred_game_genere || []
                      ).join(", ") || "N/A"}{" "}
                    </p>
                  </div>
                </div>
              )}
              {memberData?.more_profile_details?.smokes && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Has Smoking Habit?
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {memberData?.more_profile_details?.smokes || "N/A"}
                    </p>
                  </div>
                </div>
              )}
              {memberData?.more_profile_details?.drinks && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Has Drinking Habit?
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {memberData?.more_profile_details?.drinks || "N/A"}
                    </p>
                  </div>
                </div>
              )}
              {memberData?.more_profile_details?.have_pets && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Has Pets?
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {memberData?.more_profile_details?.have_pets || "N/A"}
                    </p>
                  </div>
                </div>
              )}
              {memberData?.more_profile_details?.have_pet_allergies && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Has Pet Allergies?
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {memberData?.more_profile_details?.have_pet_allergies ||
                        "N/A"}
                    </p>
                  </div>
                </div>
              )}
              {memberData?.more_profile_details?.height && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Height
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {memberData?.more_profile_details?.height || "N/A"}
                    </p>
                  </div>
                </div>
              )}
              {memberData?.more_profile_details?.body_type && (
                <div className="row-view space-around">
                  <div className="modal-label">
                    <p className="label-text" style={{ textAlign: "left" }}>
                      Body Type
                    </p>
                  </div>
                  <div style={{ width: "5%" }}>
                    <p className="label-text" style={{ textAlign: "right" }}>
                      :
                    </p>
                  </div>
                  <div className="modal-text-view">
                    <p className="value-text" style={{ textAlign: "right" }}>
                      {memberData?.more_profile_details?.body_type || "N/A"}
                    </p>
                  </div>
                </div>
              )}
              <button
                className="close-modal-button"
                onClick={() => setModalVisible(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MemberProfileModal;
